import { MutationType, TargetType } from '@tencent/slide-sdk-pb-model';
import { getDataExtensionKeyframe } from './get-data-extension-keyframe';
import type { IThemeData } from '../data';
import type { IValidAddThemeMutationData, IValidMutationData } from '../mutation/base';

export function getThemeKeyframe(theme: IThemeData): IValidMutationData[] {
    return [
        {
            type: MutationType.AddTheme,
            themeId: theme.id,
            themeName: theme.name ?? '',
            themeElements: theme.themeElements ?? {},
        } satisfies IValidAddThemeMutationData,
        ...getDataExtensionKeyframe(TargetType.Theme, theme, undefined, theme.id),
    ];
}
